import { createSimpleSelector } from '@dbh/reselect-extra';
import { makeSelectDaybreakHeroData } from '@dbh/daybreak-hero-redux';
import { createSelector } from 'reselect';
import { makeSelectReactRouterPageType, makeSelectCountry } from '@dbh/routing-redux';
import 'invariant';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';
import _noop from 'lodash/noop';
import 'prop-types';
import { createContext } from 'react';
import { select } from 'redux-saga/effects';

/**
 * Returns a selector that returns the pixel customizations.
 * @return {Immutable.Map} .
 */const makeSelectPixelCustomizations=()=>createSimpleSelector(makeSelectDaybreakHeroData(),["customizations","tracking"]);var makeSelectPixelCustomizations$1 = makeSelectPixelCustomizations;

/**
 * Returns a selector that returns the customizations of the current page type.
 * @return {Immutable.Map?} .
 */const makeSelectSiteCustomizations=()=>createSelector(makeSelectDaybreakHeroData(),makeSelectReactRouterPageType(),(a,b)=>{if(null!=a&&a.customizations){const{[b]:c}=a.customizations;return c}});var makeSelectSiteCustomizations$1 = makeSelectSiteCustomizations;

/**
 * Returns a selector that returns the color customizations of the site.
 * @return {Object} .
 */const makeSelectCustomizedColors=()=>createSimpleSelector(makeSelectDaybreakHeroData(),["customizations","colors"]);var makeSelectCustomizedColors$1 = makeSelectCustomizedColors;

const pixelPropType=_noop;

const makeSelectIsPixelEnabled=withConformsTo("",[],a=>createSelector(makeSelectPixelCustomizations$1(),makeSelectCountry(),(b,c)=>{const d=b[a];if(!d)return !1;const e=b[a+"-disabled-in-countries"];return !e||!e.includes(c)}));/**
 * Returns a selector that returns `true` if the given pixel is enabled.
 * @param {string} pixelName .
 * @return {boolean} .
 */var makeSelectIsPixelEnabled$1 = makeSelectIsPixelEnabled;

const SiteCustomizationsContext=/*#__PURE__*/createContext();

const isPixelEnabled=withConformsTo("isPixelEnabled",[],function*(a){const b=yield select(makeSelectIsPixelEnabled$1(a));return b});/**
 * Returns `true` if the given pixel is enabled in the current country.
 * @param {string} pixelName .
 * @return {boolean} .
 */var isPixelEnabled$1 = isPixelEnabled;

export { SiteCustomizationsContext, isPixelEnabled$1 as isPixelEnabled, makeSelectCustomizedColors$1 as makeSelectCustomizedColors, makeSelectIsPixelEnabled$1 as makeSelectIsPixelEnabled, makeSelectPixelCustomizations$1 as makeSelectPixelCustomizations, makeSelectSiteCustomizations$1 as makeSelectSiteCustomizations, pixelPropType };
